$(document).ready(function() {
  var hoverTimeout;

  $('.menu__link-lv1').mouseenter(function() {
    clearTimeout(hoverTimeout);
    // Close all other dropdowns
    $('.menu__link-lv1').parent('details').not($(this).parent('details')).attr('open', false);
    // Open this dropdown
    $(this).parent('details').attr('open', true);
  });

  $('.menu__link-lv1').mouseleave(function() {
    var detailElement = $(this).parent('details');
    hoverTimeout = setTimeout(function() {
      detailElement.attr('open', false);
    }, 300); // delay in milliseconds
  });

  $('.mega-menu-wrapper').mouseenter(function() {
    clearTimeout(hoverTimeout);
  });

  $('.mega-menu-wrapper').mouseleave(function() {
    hoverTimeout = setTimeout(function() {
      // Close all dropdowns
      $('.menu__link-lv1').parent('details').attr('open', false);
    }, 300); // delay in milliseconds
  });
});
